import normalizeTouchData from './normalize-touch-data';

export default {
  normalizeTouchData,
};
